import Step from "../types/Step";
import getStepPath from "./getStepPath";

export default function isStepEqual(a: Step | undefined, b: Step | undefined) {
    if (typeof a === "undefined" || typeof b === "undefined") {
        return a === b;
    }

    return getStepPath(a) === getStepPath(b);
};